<p-panel styleClass="panel-shadow" header="Late Status" [style]="{ 'margin-top': '1em' }">
  <div
    *ngIf="awaitingAllocation; else showDetails"
    class="py-3 text-center"
    style="font-weight: 500; color: #999"
  >
    Awaiting Allocation
  </div>

  <ng-template #showDetails>
    <div class="">
      <div><b>Pick-up</b></div>

      <div class="grid-label-value">
        <div class="">Status:</div>
        <div class="value">
          {{ getLateStatusTitle(lateStatusTask?.pickupLateStatusId) || 'On-Time' }}
        </div>
      </div>

      <div class="grid-label-value" *ngIf="lateStatusTask?.pickupLateReason?.length > 0">
        <div class="">Reason:</div>
        <div class="value">{{ lateStatusTask?.pickupLateReason }}</div>
      </div>
    </div>

    <div style="border-top: 1px solid #dfdfdf; padding-top: 10px; margin-top: 10px"></div>

    <div>
      <div><b>Drop-off</b></div>
      <div class="grid-label-value">
        <div class="">Status:</div>
        <div class="value">
          {{ getLateStatusTitle(lateStatusTask?.dropoffLateStatusId) || 'On-Time' }}
        </div>
      </div>

      <div class="grid-label-value" *ngIf="lateStatusTask?.dropoffLateReason?.length > 0">
        <div class="">Reason:</div>
        <div class="value">{{ lateStatusTask?.dropoffLateReason }}</div>
      </div>
    </div>

    <div class="text-right" *ngIf="organisationTypeId == 1">
      <button
        pButton
        label="Change"
        (click)="showLateStatusesDialog()"
        class="ui-button-secondary"
      ></button>
    </div>
  </ng-template>
</p-panel>

<p-dialog
  header="Change Late Statuses"
  [(visible)]="isShownLateStatusesDialog"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <div class="ui-g" style="position: relative">
    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Pick-up Late Status</label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown
          [options]="lateStatusesSelectItems"
          [style]="{ width: '100%' }"
          [(ngModel)]="lateStatusesEdited.pickupLateStatusId"
        ></p-dropdown>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Pick-up Late Reason</label>
      </div>
      <div class="ui-grid-col-8">
        <textarea
          pInputTextarea
          [(ngModel)]="lateStatusesEdited.pickupLateReason"
          [rows]="2"
          [maxlength]="250"
          style="width: 100%"
        ></textarea>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Drop-off Late Status</label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown
          [options]="lateStatusesSelectItems"
          [style]="{ width: '100%' }"
          [(ngModel)]="lateStatusesEdited.dropoffLateStatusId"
        ></p-dropdown>
      </div>
    </div>
    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Drop-off Late Reason</label>
      </div>
      <div class="ui-grid-col-8">
        <textarea
          pInputTextarea
          [(ngModel)]="lateStatusesEdited.dropoffLateReason"
          [rows]="2"
          [maxlength]="250"
          style="width: 100%"
        ></textarea>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="text-right">
      <button
        type="button"
        (click)="isShownLateStatusesDialog = false"
        pButton
        label="Cancel"
        class="ui-button ui-button-tertiary"
      ></button>
      <button
        type="button"
        pButton
        label="Save"
        class="ui-button ui-buttion-primary"
        [disabled]="lateReasonsValid"
        (click)="saveLateStatuses()"
      ></button>
    </div>
  </p-footer>
</p-dialog>
